var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30633 7.17394L2.24393 11.8288C2.14513 11.942 2.00643 12 1.86703 12C1.75033 12 1.63323 11.9594 1.53843 11.8767C1.33033 11.6951 1.30893 11.3793 1.49053 11.1712L5.67163 6.38044L6.30633 7.17394ZM7.66283 5.61964L11.8439 0.828841C12.0255 0.620741 12.004 0.304941 11.796 0.123341C11.588 -0.0582586 11.272 -0.0368586 11.0905 0.171241L7.02813 4.82614L7.66283 5.61964Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3687 12H9.76874C9.61684 12 9.47314 11.931 9.37834 11.8124L0.578336 0.8124C0.458236 0.6623 0.434836 0.4567 0.518136 0.2834C0.601436 0.1101 0.776535 0 0.968735 0H3.56874C3.72064 0 3.86434 0.0689999 3.95914 0.1876L12.7591 11.1876C12.8792 11.3377 12.9026 11.5433 12.8193 11.7166C12.736 11.8899 12.5609 12 12.3687 12ZM10.009 11H11.3283L3.32834 1H2.00904L10.009 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.d34169103ef38f7fb6659aa2d75fc882.svg";
export { ForwardRef as ReactComponent };